"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = onErrorResumeNext;
/**
 * Calls the function and returns its return value.
 *
 * If the function failed, return default value if specified, otherwise, `undefined`.
 */
function onErrorResumeNext(fn, defaultValue) {
  try {
    return fn();
  } catch (error) {
    return defaultValue;
  }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJvbkVycm9yUmVzdW1lTmV4dCIsImZuIiwiZGVmYXVsdFZhbHVlIiwiZXJyb3IiXSwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdXRpbHMvb25FcnJvclJlc3VtZU5leHQudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gb25FcnJvclJlc3VtZU5leHQ8VD4oZm46ICgpID0+IFQpOiBUIHwgdW5kZWZpbmVkO1xuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gb25FcnJvclJlc3VtZU5leHQ8VCwgVSA9IFQ+KGZuOiAoKSA9PiBULCBkZWZhdWx0VmFsdWU6IFUpOiBUIHwgVTtcblxuLyoqXG4gKiBDYWxscyB0aGUgZnVuY3Rpb24gYW5kIHJldHVybnMgaXRzIHJldHVybiB2YWx1ZS5cbiAqXG4gKiBJZiB0aGUgZnVuY3Rpb24gZmFpbGVkLCByZXR1cm4gZGVmYXVsdCB2YWx1ZSBpZiBzcGVjaWZpZWQsIG90aGVyd2lzZSwgYHVuZGVmaW5lZGAuXG4gKi9cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIG9uRXJyb3JSZXN1bWVOZXh0PFQ+KGZuOiAoKSA9PiBULCBkZWZhdWx0VmFsdWU/OiBUKTogVCB8IHVuZGVmaW5lZCB7XG4gIHRyeSB7XG4gICAgcmV0dXJuIGZuKCk7XG4gIH0gY2F0Y2ggKGVycm9yKSB7XG4gICAgcmV0dXJuIGRlZmF1bHRWYWx1ZTtcbiAgfVxufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFHQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ2UsU0FBU0EsaUJBQWlCQSxDQUFJQyxFQUFXLEVBQUVDLFlBQWdCLEVBQWlCO0VBQ3pGLElBQUk7SUFDRixPQUFPRCxFQUFFLENBQUMsQ0FBQztFQUNiLENBQUMsQ0FBQyxPQUFPRSxLQUFLLEVBQUU7SUFDZCxPQUFPRCxZQUFZO0VBQ3JCO0FBQ0YifQ==